export const splitStringAtSentence = (text: string, wordCount: number): [string, string] => {
  const words = text.split(' ')

  if (words.length <= wordCount) return [text, '']

  let splitIndex = wordCount

  // Look for punctuation (., !, ?) after the word count
  while (splitIndex < words.length && !/[.!?]/.test(words[splitIndex])) {
    splitIndex++
  }

  // If no punctuation is found, fall back to splitting at the word count
  if (splitIndex >= words.length) splitIndex = wordCount

  const firstPart = words
    .slice(0, splitIndex + 1)
    .join(' ')
    .trim()
  const secondPart = words
    .slice(splitIndex + 1)
    .join(' ')
    .trim()

  return [firstPart, secondPart]
}
